import {Table, TableOptions} from "@tiptap/extension-table";
import {Command, Node as TiptapNode} from "@tiptap/core";
import {Node as ProseMirrorNode, TableMap, updateColumnsOnResize} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/tiptap/prosemirror-eksporter";
import {erIkkeTomCellSelection} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/tiptap/tiptapHjelpere";
import {finnNodensNærmesteForelderAvType} from "felles-ng2/støttefunksjoner/dom";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";


/**
 * Utvider tiptaps Table med støtte for å resette statiske celle-bredder.
 *
 * Merk at vi per nå ikke støtter style-attributtet eller andre table-attributer (feks border),
 * skulle dette vært støttet måtte disse vært deklarert via addAttributes her, samt at
 * TableView (angitt via {@link TableOptions#View}) må overstyres for å anvende disse properties
 * også på editor-domen.
 */
export const Tabell = (): TiptapNode<TableOptions> => {
    return Table.extend({

        //se 'interface Commands' lenger ned for dokumentasjon
        addCommands():TabellKommandoer<Command> {
            return {
                ...this.parent?.(),

                /** Fjerner angivelse av bredde på kolonne */
                resettBredder: () => (props) => {
                    if (!erIkkeTomCellSelection(this.editor.state.selection)) return false; //en eller flere tabellceller må være valgt når denne kommandoen kalles
                    if (!props.dispatch) return true;

                   // props.editor.$pos(0).
                    const tabellcelle = this.editor.state.selection.$anchorCell

                    return props.chain()
                      //nullstiller først colwidth, som er attributet tableColumnResizing pluginet legger til
                      .setCellAttribute('colwidth', undefined)
                      //sørger så for at den oppdaterte colwidth-verdien får effekt i DOMen
                      .command((props) => {
                          const tabell: ProseMirrorNode = tabellcelle.node(-1);
                          const start = tabellcelle.start(-1);
                          const kolonne = TableMap.get(tabell).colCount(tabellcelle.pos - start) + tabellcelle.nodeAfter!.attrs.colspan - 1;
                          const tabellDomNode = finnNodensNærmesteForelderAvType(props.view.domAtPos(tabellcelle.start(-1)).node, 'table')
                          if (erNil(tabellDomNode)) return false;
                          updateColumnsOnResize(
                            tabell,
                            tabellDomNode.firstChild as HTMLTableColElement,
                            tabellDomNode as HTMLTableElement,
                            this.options.cellMinWidth,
                            kolonne
                          );

                          return true;
                      })
                      .run()
                }
            }
        },

    });
}


// typedefinisjoner

interface TabellKommandoer<ReturnType> {
    /** Resetter (fjerner) eventuelt colwidth attributt satt på markerte celler */
    resettBredder: () => ReturnType
}

//for at kommandoene skal dukke opp i editor ts typen
declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        tabell: TabellKommandoer<ReturnType>;
    }
}
